import atr from "./atr";
import sma from "./sma";
import { STARCBands as defaultOptions } from "./defaultOptionsForComputation";
import { isFiniteNumber } from "../utils";

export default function () {
  let options = defaultOptions;

  function calculator(data = []) {
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }

    const period = Math.max(
      1,
      Math.floor(options?.period ?? defaultOptions.period ?? 15),
    );
    const maPeriod = Math.max(
      1,
      Math.floor(options?.maPeriod ?? defaultOptions.maPeriod ?? 5),
    );
    const multiplier = Number(
      options?.multiplier ?? defaultOptions.multiplier ?? 1.3,
    );
    const sourcePath =
      options?.sourcePath ?? defaultOptions.sourcePath ?? "close";

    // Calculate SMA for the median line
    const smaCalculator = sma().options({ windowSize: maPeriod, sourcePath });

    // Calculate ATR for the bands
    const atrCalculator = atr().options({ windowSize: period });

    const smaValues = smaCalculator(data);
    const atrValues = atrCalculator(data);

    const results = new Array(data.length).fill(undefined);

    for (let i = 0; i < data.length; i += 1) {
      const mid = smaValues[i];
      const width = atrValues[i];

      if (!isFiniteNumber(mid) || !isFiniteNumber(width)) {
        continue;
      }

      results[i] = {
        top: mid + multiplier * width,
        middle: mid,
        bottom: mid - multiplier * width,
      };
    }

    return results;
  }

  calculator.undefinedLength = function () {
    const period = Math.max(
      1,
      Math.floor(options?.period ?? defaultOptions.period ?? 15),
    );
    const maPeriod = Math.max(
      1,
      Math.floor(options?.maPeriod ?? defaultOptions.maPeriod ?? 5),
    );
    // Return the maximum of the two periods
    return Math.max(period, maPeriod) - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
